import type { ConfirmOptions } from './types'

import { useUiStore } from '@/shared/ui/store/uiStore'

// Imperative confirm. Resolves to a Promise<boolean>; rendered by <ConfirmHost/> via Modal.
export function useConfirm() {
  const store = useUiStore()
  return (options: ConfirmOptions): Promise<boolean> => store.requestConfirm(options)
}
